import { render, staticRenderFns } from "./EffortDetail.vue?vue&type=template&id=cca5b7d0&"
import script from "./EffortDetail.vue?vue&type=script&lang=js&"
export * from "./EffortDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports